import React, { useEffect, useState } from 'react';
import CodeEditor from '../../../../../components/material-ui/code_editor/CodeEditor';
import { Stack } from '@mui/material';
import CasinoBtnSave from '../../../../../components/casino/CasinoBtnSave';
import useNumberParams from '../../../../../hooks/useNumberParams';
import { API_CASINO } from '../../../../../api/casino';
import useToast from '../../../../../hooks/useToast';

export default function InsertBodyContent() {
  const { successToast } = useToast();
  const [insertText, setInsertText] = useState('');

  const casinoId = useNumberParams('casinoId');

  useEffect(() => {
    API_CASINO.insertHtml
      .get({ casinoId })
      .then((e) => {
        const code = e.data.code;
        setInsertText(code.beforeEndBody);
      })
      .catch(console.error);
  }, [casinoId]);

  const onCasinoClick = () => {
    console.log('insertText', insertText);

    API_CASINO.insertHtml
      .set({ casinoId, beforeEndBody: insertText })
      .then(() => {
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  return (
    <Stack gap={2}>
      <CodeEditor
        label={'Insert HTML before the </body> tag'}
        text={insertText}
        setText={setInsertText}
        isOpenFind={false}
        mode="html"
      />
      <CasinoBtnSave onClick={onCasinoClick} />
    </Stack>
  );
}
